import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import _ from "lodash";

export const addExecutionFlow = async (data) => {
  let input = {
    ...data,
    parameters: JSON.stringify(_.omit({...data}, ["executionFlowTypeId", "comments"]))
  };
  
  return base.post({
    url: `${API_PARAM.ADD_EXECUTION_FLOW}`,
    nonceHeader: true,
    data: input
  });
};

export const getExecutionFlowTypes = async () => {
  return base.get({
    url: API_PARAM.EXECUTION_FLOW_TYPES,
  });
};
